type CallbackFn = (v: string | null) => void

interface WindowWithNativeCallback {
  mobilemissionsweb?: {
    onNewAccessToken?: CallbackFn
  }
}

// Type-safe wrapper over window.missionsweb.onNewAccessToken API.
class CallbackNewAccessToken {
  private windowObj: WindowWithNativeCallback
  constructor() {
    this.windowObj = window as WindowWithNativeCallback
  }

  set(fn: CallbackFn) {
    this.windowObj.mobilemissionsweb = {
      ...this.windowObj.mobilemissionsweb,
      onNewAccessToken: fn
    }
  }

  get(): CallbackFn | undefined {
    return this.windowObj?.mobilemissionsweb?.onNewAccessToken
  }
}

export const callbackNewAccessToken = new CallbackNewAccessToken()
